import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';

import Typography from 'Components/UI/Typography';
import FinancialInstitutionImage from '../FinancialInstitutionImage';
import Institution from './Institution';

const FinancialInstitutionImagePicker = ({
  resource, width, variant, ...rest
}) => {
  return pickFunction(resource, {
    [fr.relationships.icon.name]: () => {
      return (
        <FinancialInstitutionImage
          src={resource.relationship(fr.relationships.icon.name).link('related').url()}
          width={width}
          {...rest}
        />
      );
    },
    [fr.relationships.logo.name]: () => {
      return (
        <FinancialInstitutionImage
          src={resource.relationship(fr.relationships.logo.name).link('related').url()}
          width={width}
          {...rest}
        />
      );
    },
    [fr.relationships.institution.name]: () => {
      return (
        <Institution
          resource={resource}
          width={width}
          {...rest}
        />
      );
    },
    [fr.relationships.default.name]: () => {
      const title = resource.attr('title') ? resource.attr('title') : resource.attr('name');
      return (
        <Typography
          color={'primary'}
          variant={'h6'}
          weight={'bold'}
          noWrap
        >
          {title}
        </Typography>
      );
    },
  });
};

export default FinancialInstitutionImagePicker;
